import React from 'react';
import JesusImg from '../style/images/Jesus.png';
import Whatsapp  from './Whatsapp';

export default function Programa() {
    return (
        <section id="inscricao" className="section-lines">
            <div className="container">
                <div className="margin-bottom-20 margin-top-30">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="titulo">Inscrição</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                            <p className="p-md">
                                Para participar conosco dessa jornada é muito simples &nbsp;<span role="img" aria-label="">🤓</span>, basta preencher o <span>formulário de inscrição</span>, ou então
                                enviar uma mensagem para nós no <span>WhatsApp</span>.&nbsp;<span role="img" aria-label="">👏👏👏</span>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 text-center">
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSd9dRkRECOINmiF1Wdq5RGgALhv_Qg6HCj16rjXlMEMyLYQvg/viewform?usp=header" target="_blank" rel="noopener noreferrer" className="btn btn-danger botaoFormulario animated wow slideInLeft animation-delay-1">Formulário</a>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 text-center">
                            <Whatsapp />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                            <img className="JesusImg img-fluid animated wow slideInRight animation-delay-1" alt="Jesus" src={JesusImg} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}